import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Navigation } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for navigation list query
const CACHE_TIME = 30 * 60 * 1000;

export const useNavigationsQuery = () => {
  const { apiUrl } = useGlobalContext();
  const accessToken = getAccessToken();

  return useQuery({
    queryKey: ['navigations', apiUrl],
    queryFn: () => fetchNavigations(apiUrl),
    staleTime: !accessToken ? CACHE_TIME : undefined,
    enabled: !!apiUrl,
  });
};

const fetchNavigations = async (apiUrl: string): Promise<Navigation> => {
  const { data } = await axios.get<Navigation>(`${apiUrl}${API.endpoints.navigations}`);
  return data;
};
